var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare53AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 80",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M48.5 51a1.5 1.5 0 0 0 1.5-1.5v-19a1.5 1.5 0 0 0-1.5-1.5h-19a1.5 1.5 0 0 0-1.5 1.5v19a1.5 1.5 0 0 0 1.5 1.5h19Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M16.5 39.5A2.5 2.5 0 0 0 19 37V25.5a2.5 2.5 0 0 0-2.5-2.5h-10A2.5 2.5 0 0 0 4 25.5v14h12.5ZM39.5 17.5A2.5 2.5 0 0 0 42 20h11.5a2.5 2.5 0 0 0 2.5-2.5v-10A2.5 2.5 0 0 0 53.5 5h-14v12.5ZM16.5 57a2.5 2.5 0 0 0 2.5-2.5V43a2.5 2.5 0 0 0-2.5-2.5H4v14A2.5 2.5 0 0 0 6.5 57h10ZM22 17.5a2.5 2.5 0 0 0 2.5 2.5H36a2.5 2.5 0 0 0 2.5-2.5V5h-14A2.5 2.5 0 0 0 22 7.5v10Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M14 57H6.5A2.5 2.5 0 0 1 4 54.5v-29A2.5 2.5 0 0 1 6.5 23H14M22 15V7.5A2.5 2.5 0 0 1 24.5 5h29A2.5 2.5 0 0 1 56 7.5V15"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 39.5,
  cy: 67.5,
  r: 6.5,
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  transform: "rotate(-90 39.5 67.5)"
})));
SvgSquare53AError.viewBox = '0 0 60 80';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare53AError);
export default ForwardRef;